import React from 'react';
import { useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { useAnimatePage } from '@hooks';
import Header from '@components/Header';
import { AnimationLayout } from '@layouts';
import { useStyles } from './styles';
import Sidebar from '@components/Sidebar';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { useAuthContext, useDrawerContext } from '@hooks';

export function HeaderLayout({ children, title, pageMayClosed }) {
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const animation = useAnimatePage();
  const styles = useStyles();
  const { pathname } = useLocation();
  const { session } = useAuthContext();
  const { openDrawer } = useDrawerContext();
  const pagesWithZeroPadding = ['/menu', '/advice-screen'];
  const idx = pagesWithZeroPadding.indexOf(pathname);
  const paddingContentStyle = {
    padding: idx > -1 ? '0' : '0px 24px 20px 103px',
  };

  function decideMarginLeft(pathname) {
    if (pathname === '/menu' || !session.staff) return 100;
    return 204;
  }
  const headingStyle =
    pathname === '/advice-screen'
      ? {
          margin: '1rem 12px 20px',
          paddingBottom: 10,
          borderBottom: '1px solid #43566C',
        }
      : {};

  const dividerStyle = {
    display: pathname === '/advice-screen' ? 'none' : 'flex',
  };

  console.log('pathname', pathname);
  return (
    <div className={styles.layoutContainer}>
      <CssBaseline />
      <AppBar className={styles.appBar}>
        <Toolbar>
          <Header pageMayClosed={pageMayClosed} />
        </Toolbar>
      </AppBar>

      <AnimationLayout animation={animation}>
        {session.staff && pathname !== '/menu' && pathname !== '/visit' && (
          <Sidebar />
        )}
        <div className={styles.content} style={paddingContentStyle}>
          <Box
            className={styles.main}
            style={{
              marginLeft:
                openDrawer && !matchesSM
                  ? decideMarginLeft(window.location.pathname)
                  : undefined,
            }}
          >
            {title && (
              <>
                <Typography
                  variant="h6"
                  className={styles.heading}
                  style={headingStyle}
                >
                  {title}
                </Typography>
                <span className={styles.Divider} style={dividerStyle} />
              </>
            )}
            {children}
          </Box>
        </div>
      </AnimationLayout>
    </div>
  );
}
